export default {
  'Text': 'Metin',
  'Styles': 'Stil',
  'Text here': 'Metin buraya',
  'Add subtitles': 'Metin ekle',
  'Text Color': 'Metin rengi',
  'Outline': 'Anahat',
  'Background': 'Arka plan',
  'Position': 'Konum',
}